module.exports = __webpack_public_path__ + "img/32.70fc43f1.jpg";